import React from "react"
import { Controller, FormProvider, useForm } from "react-hook-form"
import ContentSection from "../ContentSection"
import Button from "../core/Button/Button"
import { ReactComponent as KeyHome } from "../../../assets/images/habitacional/KeyHome-Image.svg"
import useWindowSize from "../../../hooks/useWindowSize";
import InputText from "../core/Form/InputText";
import useAuthToken from "../../../hooks/requests/useAuthToken"

const CtaTrakingYourClaimWithCpf = () => {
    const { width } = useWindowSize();
    const isDesktop = width >= 768;
    const defaultDescription = "Informe o número do pedido de indenização (sinistro) ou CPF do titular do contrato e confira como está o andamento do processo."
    
    const { refreshToken } = useAuthToken()

    const methods = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
    })

    const { handleSubmit, getValues, control, formState: { errors } } = methods

    async function onSubmit() {
        const data = getValues()
        await refreshToken()
        window.open(`/paravoce/habitacional/acompanhar-pedidos/${data.SearchForCompensation}`, '_ blank')
    }

    return (
        <ContentSection
            reverse
            illustration={isDesktop ? <KeyHome /> : undefined}
            title="Acompanhe o andamento do seu pedido de indenização (sinistro)"
            description={defaultDescription}
        >
            <FormProvider {...methods} >
                <form style={{ marginTop: '40px' }} onSubmit={handleSubmit(onSubmit)}>
                    <Controller
                        name="SearchForCompensation"
                        control={control}
                        render={({ field }) => (
                            <InputText
                                id="SearchForCompensation"
                                name="SearchForCompensation"
                                title="Digite o número do pedido ou CPF do titular"
                                placeholder="Número do pedido ou CPF"
                                hasError={errors?.SearchForCompensation?.message}
                                errorMessage={errors?.SearchForCompensation?.message}
                                value={field.value}
                                onChange={(e) => { field.onChange(e.target.value) }}
                                isRequired
                                {...field}
                            />
                        )}
                    />
                    <Button variant="primary" style={{ marginTop: "32px" }}>Consultar</Button>
                </form>
            </FormProvider>
        </ContentSection >
    )
}

export default CtaTrakingYourClaimWithCpf